var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.isAuthenticated)?_c('AppHeader'):_vm._e(),(this.isAuthenticated)?_c('AppSide'):_vm._e(),_c('div',{staticClass:"main"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }